import { FeatureHelperService } from './../../_helpers/feature-helper/feature-helper.service';
import { TutorReportsHelperService } from '../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { Component, ViewChild, OnInit, OnDestroy, Input } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ProgressReportInfo, StudentOutcome, PlacementData } from '../../_models/index';
import { ColumnDef } from '../../shared/data-table/data-table.model';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PlacementService, ActionService } from "../../_services/index";

import { SuccessModalHelperService } from '../../_helpers/success-modal-helper/success-modal-helper.service';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { TutorReportsOutcomeDetailComponent } from './tutor-reports.outcome-detail/tutor-reports.outcome-detail.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'student-outcomes',
    templateUrl: 'tutor-reports.outcomes.component.html',
    styleUrls: ['tutor-reports.outcomes.component.css'],
    standalone: false
})

export class StudentOutcomesComponent implements OnInit, OnDestroy {
  @ViewChild(TutorReportsOutcomeDetailComponent, { static: false }) outcomeDetails;

  @Input() groupStudentId?: number;
  @Input() groupStudentFullName?: string;
  
  showAddButton: Boolean = true;
  showPanel: boolean = false;
  actionItem: any = {};
  columns: ColumnDef<StudentOutcome>[] = [
    { field: 'id', header: 'ID.' },
    { field: 'keyStageData', header: 'Key Stage' },
    { field: 'outcomeDate', header: 'Date', type: 'date' },
    { field: 'comments', header: 'Comments', type: 'template' },
    { field: 'statusDescription', header: 'Status' },
    { field: 'action', header: 'Action', type: 'template' }
  ];
  rows: StudentOutcome[] = [];
  pageEvent: PageEvent;
  private model: Array<ProgressReportInfo> = new Array<ProgressReportInfo>();
  childPanelClosed: boolean = false;

  public loading = false;

  public hasGridEditPermission: boolean = false;
  public hasGridViewPermission: boolean = false;
  public hasAddPermission: boolean = false;
  public hasDeletePermission: boolean = false;
  public hasUnlockPermission: boolean = false;

  public sessionStudentId: number;
  public placementData: PlacementData;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public dialog: MatDialog, 
    private placementService: PlacementService,
    private actionService: ActionService,
    private successModalHelper: SuccessModalHelperService,
    public tutorReportsHelperService: TutorReportsHelperService,
    private featureHelperService: FeatureHelperService,
    private errorModalHelper: ErrorModalHelperService,
    public themeService: ThemeService
    ) {
    let permissionRequirements = new Array<string>();
    permissionRequirements.push("TutorReportsGridItemEdit", "TutorReportsGridItemView", "ProgressReportsAdd", "ProgressReportsSave", "UnlockProgressReports");
    let permissionsResult = this.featureHelperService.checkFeaturePermissions(permissionRequirements);
    
    this.hasAddPermission = permissionsResult.filter(p => p.feature === "ProgressReportsAdd")[0].enabled;
    this.hasDeletePermission = permissionsResult.filter(p => p.feature === "ProgressReportsSave")[0].enabled;
    this.hasUnlockPermission = permissionsResult.filter(p => p.feature === "UnlockProgressReports")[0].enabled;
    this.hasGridEditPermission = permissionsResult.filter(p => p.feature === "TutorReportsGridItemEdit")[0].enabled;
    this.hasGridViewPermission = permissionsResult.filter(p => p.feature === "TutorReportsGridItemView")[0].enabled;

    this.tutorReportsHelperService.placementData$
      .pipe(
        filter((d): d is PlacementData => d != null),
        takeUntil(this.unsubscribe)
      )
      .subscribe(pd => this.placementData = pd);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnInit() {
    this.getData();
    this.showPanel = false;

    this.actionService.currentMessage.subscribe(message => {
      this.actionItem = message;
    });

    this.sessionStudentId = this.groupStudentId == undefined ? this.placementData.studentId : this.groupStudentId;
  }

  addRowData(row_obj) {
    this.tutorReportsHelperService.progressReport = new ProgressReportInfo();
    this.tutorReportsHelperService.progressReport.currentReport = null;
    let previousReport = null;
    if (this.model && this.model.length > 0) {
      previousReport = this.model[0].currentReport ? this.model[0].currentReport : this.model[0].previousReport;
      previousReport.targetForOutcome = this.tutorReportsHelperService.baselineTargetForOutcome;
    }
    this.tutorReportsHelperService.progressReport.previousReport = previousReport;
    this.showPanel = true;

    setTimeout(() => {
      if (this.outcomeDetails) {
        this.outcomeDetails.showPanel = true;
        this.outcomeDetails.groupStudentFullName = this.groupStudentFullName;
        this.outcomeDetails.setFocus();
      }

    }, 10);
  }

  updateRowData(row_obj) {
    this.tutorReportsHelperService.progressReport = this.model.filter(p => p.currentReport.id == row_obj.id)[0];
    this.showPanel = true;

    setTimeout(() => {
      if (this.outcomeDetails) {
        this.outcomeDetails.showPanel = true;
        this.outcomeDetails.ngOnInit();
        this.outcomeDetails.setFocus();
      }
    }, 0);
  }

  deleteRowData(row_obj) {
    if (!row_obj.approved) {
      this.placementService.deleteOutcome(row_obj.id).subscribe(data => {
          this.successModalHelper.show('Progress report successfully deleted');
          var actionData = {
            placementId: this.tutorReportsHelperService.commonData.placementId,
            rowId: row_obj.id,
            appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
            section: 'PR'
          };

          this.actionService.deleteAction(actionData).subscribe(action => {
          });

          this.ngOnInit();
        },
        error => {
          this.errorModalHelper.show(error.message, error);
        }
      );
    }
    else {
      this.errorModalHelper.show('Cannot delete an approved Progress Report', {isValidationError: true});
    }
  }

  public unlockProgressReport(studentOutcome: StudentOutcome): void {
    
    
    this.placementService.unlockProgressReport(studentOutcome.id, this.sessionStudentId).subscribe(response => {
      this.successModalHelper.show("Successfully unlocked the session");
      this.showPanel = false;
      this.getData();
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });
  }

  public getData() {
    if (this.tutorReportsHelperService.commonData.placementId != null) {
      this.placementService.getStudentOutcomes(this.tutorReportsHelperService.commonData.placementId, this.groupStudentId, this.groupStudentId != null).subscribe((data: ProgressReportInfo[]) => {
        this.model = data;
        if (!data[0].currentReport && !data[0].previousReport) {
          this.model = null;
        }

        if (this.actionItem && Object.keys(this.actionItem).length !== 0 && (this.actionItem.actionType.section === 'PR')) {
          this.tutorReportsHelperService.progressReport = this.model.filter(x => x.currentReport.id === this.actionItem.rowId)[0];
            this.showPanel = false;
        }

        if (this.model && this.model.length > 0){
          this.tutorReportsHelperService.progressReport = this.model[0];
          let currentReports = this.model.map(m => m.currentReport);
          if (currentReports[0] == null) {
            currentReports = new Array<StudentOutcome>();
          }
          this.rows = currentReports;
        } else {
          this.tutorReportsHelperService.progressReport = null;
        }
        
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        });
    }
  }

  public onDataSavedGet(saved: any): void {
    this.ngOnInit();
    this.showPanel = !saved;
  }

  public onClosed(closed: boolean): void {
    this.ngOnInit();
    this.showPanel = false;
    this.childPanelClosed = true;
  }

  public enableViewEditButtons(element) {
    
    if (!element.approved && !element.submitted) {
      return "Edit";
    } else if (this.hasGridEditPermission && element.statusDescription != "Approved") {
      return "Edit";
    }
    return 'View';
  }

}
